import { render, staticRenderFns } from "./InstructionsList.vue?vue&type=template&id=43a620ac&scoped=true&"
import script from "./InstructionsList.vue?vue&type=script&lang=js&"
export * from "./InstructionsList.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsList.vue?vue&type=style&index=0&id=43a620ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a620ac",
  null
  
)

export default component.exports